var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_3635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 5.00016C10 5.44219 10.1756 5.86611 10.4882 6.17867C10.8007 6.49123 11.2246 6.66683 11.6667 6.66683C12.1087 6.66683 12.5326 6.49123 12.8452 6.17867C13.1577 5.86611 13.3333 5.44219 13.3333 5.00016C13.3333 4.55814 13.1577 4.13421 12.8452 3.82165C12.5326 3.50909 12.1087 3.3335 11.6667 3.3335C11.2246 3.3335 10.8007 3.50909 10.4882 3.82165C10.1756 4.13421 10 4.55814 10 5.00016Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 5H9.99992",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5H16.6666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.0002C5 10.4422 5.17559 10.8661 5.48816 11.1787C5.80072 11.4912 6.22464 11.6668 6.66667 11.6668C7.10869 11.6668 7.53262 11.4912 7.84518 11.1787C8.15774 10.8661 8.33333 10.4422 8.33333 10.0002C8.33333 9.55814 8.15774 9.13421 7.84518 8.82165C7.53262 8.50909 7.10869 8.3335 6.66667 8.3335C6.22464 8.3335 5.80072 8.50909 5.48816 8.82165C5.17559 9.13421 5 9.55814 5 10.0002Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 10H4.99992",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 10H16.6666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.0002C12.5 15.4422 12.6756 15.8661 12.9882 16.1787C13.3007 16.4912 13.7246 16.6668 14.1667 16.6668C14.6087 16.6668 15.0326 16.4912 15.3452 16.1787C15.6577 15.8661 15.8333 15.4422 15.8333 15.0002C15.8333 14.5581 15.6577 14.1342 15.3452 13.8217C15.0326 13.5091 14.6087 13.3335 14.1667 13.3335C13.7246 13.3335 13.3007 13.5091 12.9882 13.8217C12.6756 14.1342 12.5 14.5581 12.5 15.0002Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 15H12.4999",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 15H16.6666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_3635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.0901d7fa83695d29edefa573ff604272.svg";
export { ForwardRef as ReactComponent };